import React from 'react';

const AlertHighLight = ({ textFragment }: { textFragment: string }) => {
  return <div className='hight-light-keyword' dangerouslySetInnerHTML={{ __html: textFragment }} />;
};

export default AlertHighLight;
